import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filesize'
})
export class FilesizePipe implements PipeTransform {

	/**
	 * Format bytes as human-readable text.
	 * 
	 * @param bytes Number of bytes.
	 * @param si True to use metric (SI) units, aka powers of 1000. False to use 
	 *           binary (IEC), aka powers of 1024.
	 * @param dp Number of decimal places to display.
	 * 
	 * @return Formatted string.
	 */
	// humanFileSize(bytes, si=false, dp=1) {
	humanFileSize(size, hasUnit=true) {

		var i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
		var s = +((size / Math.pow(1024, i)).toFixed(2)) * 1 + '';
		if(hasUnit){
			s += ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
		}
		return s;


		// const thresh = si ? 1000 : 1024;
	
		// if (Math.abs(bytes) < thresh) {
		// return bytes + ' B';
		// }
	
		// const units = si 
		// ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
		// : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
		// let u = -1;
		// const r = 10**dp;
	
		// do {
		// bytes /= thresh;
		// ++u;
		// } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
	
	
		// return bytes.toFixed(dp) + ' ' + units[u];
	}


	// transform(value: any, si=true, dp=1): unknown {
	transform(value: any, hasUnit=true): unknown {
		return this.humanFileSize(parseInt(value), hasUnit);
	}

}
